<template>
	<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-bind:class="{'modal-dialog':true,'modal-lg':large,'modal-sm':small}" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">
						<slot name="title">
							{{ title }}
						</slot>
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<slot name="modal-body">
					<div class="modal-body">
					</div>
				</slot>
				<slot name="modal-footer">
					<div class="modal-footer">
						<button type="button" class="btn btn-info" data-dismiss="modal">{{ cancelText }}</button>
						<button type="button" class="btn btn-success" @click="onOK" data-dismiss="modal">{{ okText }}</button>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {
	props: {
		okText: {
			type: String,
			default: 'OK'
		},
		cancelText: {
			type: String,
			default: 'Cancel'
		},
		title: {
			type: String,
			default: ''
		},
		large: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onOK () {
			this.$emit('ok');
		}
	}
};
</script>
<style>
.modal {
	transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// f-modal.vue?510a9f12